import { Form, FormInstance, Input } from 'antd'
import { forwardRef } from 'react'
import styled from 'styled-components'

import { RichTextEditor } from 'packages/components/RichText'
import { RichTextEditorRef } from 'packages/components/RichText/Editor/types'
import { $t } from 'packages/locale'

type NoticeEditorProps = {
  form: FormInstance<{ title: string; content: string }>
  initialValues: { title?: string; content?: string }
  onValuesChange?: () => void
  titlePlaceholder?: string
  richTextPlaceholder?: string
}

/**
 * 编辑内容
 *
 * @param param0 - 参数
 * @param param0.form - 表单
 * @param param0.initialValues - 初始值
 * @param param0.onValuesChange - 表单值变化回调
 * @param param0.titlePlaceholder - titlePlaceholder
 * @param param0.richTextPlaceholder - richTextPlaceholder
 * @returns 组件
 */
export const NoticeEditor = forwardRef<RichTextEditorRef, NoticeEditorProps>(
  (
    {
      form,
      initialValues,
      onValuesChange,
      titlePlaceholder = $t('请输入通知标题'),
      richTextPlaceholder = $t('请输入通知详情'),
    },
    ref
  ) => {
    return (
      <Wrapper>
        <Form
          form={form}
          initialValues={initialValues}
          onValuesChange={onValuesChange}
        >
          <Form.Item
            name="title"
            rules={[
              {
                required: true,
                message: titlePlaceholder,
              },
            ]}
          >
            <Input
              placeholder={titlePlaceholder}
              maxLength={50}
              showCount={true}
            />
          </Form.Item>
          <Form.Item
            name="content"
            rules={[
              {
                required: true,
                message: richTextPlaceholder,
              },
            ]}
          >
            <RichTextEditor
              placeholder={richTextPlaceholder}
              ref={ref}
              insertKeys={{
                index: 18,
                keys: ['|', 'importVariables', 'insertVariables'],
              }}
            />
          </Form.Item>
        </Form>
      </Wrapper>
    )
  }
)

const Wrapper = styled.div`
  width: 896px;
  &&& {
    .ant-form-item {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`
